import type { BlockCMS, Product } from '@/types'
import ProductCard from '../ProductCard'

interface ModuleProductListFullType {
  data: BlockCMS
  order: number
}
const ModuleProductListFull = ({ data, order }: ModuleProductListFullType) => {
  return (
    <section
      id={data._id}
      className={`${data?.type} ${data?.hideBot ? '' : 'pb-[20px]'} ${
        'order-[' + (order + 1) + ']'
      } scroll-mt-[158px]`}
    >
      <div
        className='products grid grid-cols-4 rounded-lg px-2 pt-[20px]'
        style={{
          backgroundColor: data?.color,
          backgroundImage: `url(${data?.image})`,
          backgroundSize: '100% 100%',
          backgroundRepeat: 'no-repeat',
          backgroundPosition: 'top left',
        }}
      >
        {data &&
          data?.data.map((item: Product) => (
            <ProductCard
              product={item}
              className='mb-[20px] px-2.5'
              key={item._id}
            />
          ))}
      </div>
    </section>
  )
}

export default ModuleProductListFull
